// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1mHBi","footer":"Form_footer__usVPQ"};